import Http from './base-http'

class SignupCompany extends Http {
  registerNewCompany(data) {
    return this.client.post('/register', data)
  }
}

const signupCompany = new SignupCompany({
  modelUrlPrefix : 'process/company'
})

export default signupCompany
